import { defineComponent as O, computed as k, createElementBlock as s, openBlock as o, createElementVNode as n, withDirectives as A, normalizeClass as D, createCommentVNode as l, createBlock as d, Fragment as E, createVNode as b, unref as r, normalizeStyle as v, mergeProps as I, toDisplayString as N, renderSlot as C, vShow as T } from "vue";
import { GuideIcon as S } from "@scalar-org/guide-icons";
import { ScalarIconCaretRight as w, ScalarIconArrowUpRight as V } from "@scalar/icons";
const z = { class: "sidebar-group-item" }, R = {
  key: 0,
  class: "sidebar-heading-chevron"
}, G = ["aria-controls", "aria-expanded"], U = { class: "sidebar-heading-link-title" }, j = {
  key: 2,
  class: "action-menu"
}, q = ["id"], M = /* @__PURE__ */ O({
  __name: "SidebarElement",
  props: {
    item: {},
    isActive: { type: Boolean },
    hasChildren: { type: Boolean },
    open: { type: Boolean },
    resolvePage: { type: Function }
  },
  emits: ["select", "toggleOpen"],
  setup(B, { emit: F }) {
    const t = B, a = F, P = k(() => {
      var i;
      const e = t.item;
      return e.type === "Link" ? {
        href: e.link,
        rel: "noopener noreferrer",
        target: "_blank"
      } : e.type === "Page" ? {
        href: ((i = t.resolvePage) == null ? void 0 : i.call(t, e.uid)) || "#"
      } : {};
    }), c = k(() => t.hasChildren || t.item.type === "Folder");
    function $() {
      if (t.item.type !== "Link") {
        if (t.item.type === "Folder") {
          a("toggleOpen");
          return;
        }
        a("select");
      }
    }
    function L() {
      t.item.type !== "Folder" && a("toggleOpen");
    }
    return (e, i) => {
      var m, p, u, g, y, h;
      return o(), s("li", z, [
        n("div", {
          class: D(["sidebar-heading", {
            active_page: e.isActive,
            "sidebar-group-item__folder": e.item.type === "Folder"
            /* Folder */
          }]),
          onClick: $
        }, [
          c.value ? (o(), s("p", R, [
            n("button", {
              "aria-controls": `${e.item.uid}-content`,
              "aria-expanded": e.open,
              class: "toggle-nested-icon",
              type: "button",
              onClick: L
            }, [
              i[1] || (i[1] = n("span", { class: "sr-only" }, "Toggle group", -1)),
              (p = (m = e.item) == null ? void 0 : m.icon) != null && p.src ? (o(), s(E, { key: 0 }, [
                b(r(S), {
                  class: "sidebar-icon",
                  src: e.item.icon.src
                }, null, 8, ["src"]),
                b(r(w), {
                  class: "sidebar-icon-caret hidden",
                  style: v({
                    transform: e.open ? "rotate(90deg)" : "rotate(0deg)"
                  }),
                  weight: "bold"
                }, null, 8, ["style"])
              ], 64)) : (o(), d(r(w), {
                key: 1,
                style: v({
                  transform: e.open ? "rotate(90deg)" : "rotate(0deg)"
                }),
                weight: "bold"
              }, null, 8, ["style"]))
            ], 8, G)
          ])) : l("", !0),
          n("a", I({ class: "sidebar-heading-link flex-1" }, P.value, {
            onClick: i[0] || (i[0] = (f) => e.item.type === "Link" ? f.stopPropagation() : f.preventDefault())
          }), [
            (g = (u = e.item) == null ? void 0 : u.icon) != null && g.src && !c.value ? (o(), d(r(S), {
              key: 0,
              class: "sidebar-icon",
              src: e.item.icon.src
            }, null, 8, ["src"])) : l("", !0),
            n("p", U, N(((y = e.item.sidebarTitle) == null ? void 0 : y.trim()) || e.item.title.trim() || e.item.type), 1)
          ], 16),
          ((h = e.item) == null ? void 0 : h.type) === "Link" ? (o(), d(r(V), {
            key: 1,
            class: "link-icon",
            weight: "bold"
          })) : l("", !0),
          e.$slots["action-menu"] ? (o(), s("div", j, [
            C(e.$slots, "action-menu", {}, void 0, !0)
          ])) : l("", !0)
        ], 2),
        A(n("div", {
          id: `${e.item.uid}-content`,
          class: "contents"
        }, [
          C(e.$slots, "default", {}, void 0, !0)
        ], 8, q), [
          [T, e.open]
        ])
      ]);
    };
  }
});
export {
  M as default
};
